"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "Great care for my grandmother. The carers are friendly, attentive, and provide exceptional daily support.",
  author: "B T (Granddaughter of Client)",
  country: "Hove, Brighton",
  avatar: "https://settled-jaguar.10web.cloud/wp-content/uploads/woocommerce-placeholder.webp?v=onz6ffcgin"
}, {
  id: 2,
  quote: "The carers are kind, professional, and always bring comfort and reassurance to my mum every day.",
  author: "J T (Daughter of Client)",
  country: "Brighton",
  avatar: "https://settled-jaguar.10web.cloud/wp-content/uploads/woocommerce-placeholder.webp?v=9r9mq6479mg"
}, {
  id: 3,
  quote: "Nan always looks forward to the carers visiting. She feels happy, supported, and well cared for.",
  author: "Lucy R (Granddaughter of Client)",
  country: "East Sussex",
  avatar: "https://settled-jaguar.10web.cloud/wp-content/uploads/woocommerce-placeholder.webp?v=gvliuh95la7"
}];
export default function VoicesOfExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="voices-of-our-families" className="bg-white px-4 py-16 md:px-6 lg:py-20">
      <div className="mx-auto max-w-6xl">

        {/* Heading */}
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>

          <p className="text-sm font-bold uppercase tracking-[0.2em] text-teal-700">
            Testimonials
          </p>

          <h2 className="mt-4 text-4xl font-bold tracking-tight text-slate-900 md:text-5xl">
            Voices of Our Families
          </h2>

          <p className="mt-5 text-lg leading-8 text-slate-600">
            Trusted by families across Brighton, Hove,
            and East Sussex.
          </p>

        </div>

        {/* Testimonials */}
        <div className={`mt-12 transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>

          <Carousel opts={{
          align: "start",
          loop: true
        }} className="relative">

            <CarouselContent className="-ml-4">

              {testimonials.map(testimonial => <CarouselItem key={testimonial.id} className="pl-4 md:basis-1/2 lg:basis-1/3">

                  <Card className="h-full rounded-3xl border border-slate-200 bg-slate-50 shadow-sm">

                    <CardContent className="flex h-full flex-col p-6">

                      {/* Quote */}
                      <div className="relative">

                        <span className="absolute -top-3 left-0 text-4xl text-teal-100">
                          “
                        </span>

                        <p className="pl-4 text-base leading-7 text-slate-700">
                          {testimonial.quote}
                        </p>

                      </div>

                      {/* Footer */}
                      <div className="mt-6 flex items-center gap-4 border-t border-slate-200 pt-5">

                        <SafeHydrate><Avatar className="h-11 w-11 border border-slate-200">
                          <AvatarImage src={testimonial.avatar} alt={testimonial.author} />

                          <AvatarFallback>
                            {testimonial.author.charAt(0)}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>

                        <div className="min-w-0">

                          <p className="truncate font-semibold text-slate-900">
                            {testimonial.author}
                          </p>

                          <p className="text-sm text-slate-500">
                            {testimonial.country}
                          </p>

                        </div>

                      </div>

                    </CardContent>

                  </Card>

                </CarouselItem>)}

            </CarouselContent>

            {/* Arrows */}
            <CarouselPrevious className="-left-4 top-1/2 hidden h-10 w-10 -translate-y-1/2 border-0 bg-teal-700 text-white shadow-md hover:bg-teal-800 lg:flex" />

            <CarouselNext className="-right-4 top-1/2 hidden h-10 w-10 -translate-y-1/2 border-0 bg-teal-700 text-white shadow-md hover:bg-teal-800 lg:flex" />

          </Carousel>

        </div>

      </div>
    </section>;
}